class DialogQuickBuyRenderer extends HTMLElement {
  connectedCallback () {
    this.setEventListeners()
  }

  setEventListeners () {
    document.addEventListener('quick-add:load', this.onLoad.bind(this))
    this.addEventListener('quick-add:clear', this.resetState.bind(this))
  }

  async onLoad (event) {
    this.productHandle = event.detail.handle
    this.root = event.detail.root
    await this.fetchSection()
  }

  resetState () {
    document.querySelector('html').style.overflow = 'auto'
    this.dataset.rendered = 'false'
    setTimeout(() => {
      this.innerHTML = ''
    }, 500)
  }

  async fetchSection () {
    try {
      const response = await fetch(`/products/${this.productHandle}/?section_id=dialog-quick-buy`)
      const section = await response.text()

      const innerHTML = new DOMParser()
        .parseFromString(section, 'text/html')
        .querySelector('#shopify-section-dialog-quick-buy').innerHTML

      if (this.querySelector('dialog-quick-buy')) {
        this.innerHTML = ''
      }

      this.insertAdjacentHTML('beforeend', innerHTML)

      if (this.root) {
        this.querySelector('dialog-quick-buy').setAttribute('data-root', this.root)
      }

      this.querySelector('.dialog-quick-add__dialog-inner').scrollTop = 0

      this.dataset.rendered = 'true'
    } catch (error) {
      console.error('Error:', error)
    }
  }
}

customElements.define('dialog-quick-buy-renderer', DialogQuickBuyRenderer)
